/* GODA · landing de producto (layout goda-landing) */
(() => {
  const DRAWER_SECTION = 'gl-cart-drawer';
  const TIMER_SECONDS = 300;
  const MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(async (response) => {
      const data = await response.json().catch(() => ({}));
      if (!response.ok || data.status) throw data;
      return data;
    });
  }

  function withDrawerSection(body) {
    return Object.assign(body, { sections: DRAWER_SECTION, sections_url: window.location.pathname });
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
    button.disabled = busy;
    const spinner = qs('.gl-spinner', button);
    if (spinner) spinner.hidden = !busy;
  }

  function updateCartCount(count) {
    qsa('[data-gl-cart-count]').forEach((bubble) => {
      bubble.hidden = count === 0;
      const label = qs('span', bubble);
      if (label) label.textContent = count;
    });
  }

  /* ---------- Carrito lateral ---------- */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.timerEnd = Date.now() + TIMER_SECONDS * 1000;
      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('change', (event) => this.onChange(event));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-active')) this.close();
      });
      this.tick = this.tick.bind(this);
      this.tick();
      setInterval(this.tick, 1000);
    }

    open() {
      this.classList.add('is-active');
      document.body.classList.add('gl-lock');
      const panel = qs('.gl-drawer__panel', this);
      if (panel) setTimeout(() => panel.focus({ preventScroll: true }), 50);
    }

    close() {
      this.classList.remove('is-active');
      document.body.classList.remove('gl-lock');
    }

    tick() {
      const label = qs('[data-gl-timer]', this);
      if (!label) return;
      const left = Math.max(0, Math.round((this.timerEnd - Date.now()) / 1000));
      const minutes = String(Math.floor(left / 60)).padStart(2, '0');
      const seconds = String(left % 60).padStart(2, '0');
      label.textContent = `${minutes}:${seconds}`;
    }

    render(sections) {
      const html = sections && sections[DRAWER_SECTION];
      if (!html) return;
      const fresh = qs('[data-gl-drawer-content]', new DOMParser().parseFromString(html, 'text/html'));
      const current = qs('[data-gl-drawer-content]', this);
      if (!fresh || !current) return;
      current.replaceWith(fresh);
      this.timerEnd = Date.now() + TIMER_SECONDS * 1000;
      this.tick();
      updateCartCount(Number(fresh.dataset.count || 0));
    }

    onClick(event) {
      if (event.target.closest('[data-gl-drawer-close]')) {
        event.preventDefault();
        this.close();
        return;
      }
      const line = event.target.closest('.gl-line');
      if (!line) return;
      const input = qs('[data-gl-qty-input]', line);
      const quantity = Number(input ? input.value : 1);
      if (event.target.closest('[data-gl-qty-minus]')) this.change(line, Math.max(0, quantity - 1));
      else if (event.target.closest('[data-gl-qty-plus]')) this.change(line, quantity + 1);
      else if (event.target.closest('[data-gl-remove]')) this.change(line, 0);
    }

    onChange(event) {
      if (event.target.matches('[data-gl-qty-input]')) {
        const line = event.target.closest('.gl-line');
        this.change(line, Math.max(0, parseInt(event.target.value, 10) || 0));
      } else if (event.target.matches('[data-gl-swap]')) {
        this.swap(event.target);
      }
    }

    change(line, quantity) {
      line.classList.add('is-loading');
      postJSON('/cart/change.js', withDrawerSection({ id: line.dataset.key, quantity }))
        .then((state) => this.render(state.sections))
        .catch(() => line.classList.remove('is-loading'));
    }

    swap(select) {
      const { key, current } = select.dataset;
      const quantity = parseInt(select.dataset.qty, 10) || 1;
      if (!select.value || select.value === current) return;
      select.classList.add('is-loading');
      postJSON('/cart/add.js', { id: Number(select.value), quantity })
        .then(() => postJSON('/cart/change.js', withDrawerSection({ id: key, quantity: 0 })))
        .then((state) => this.render(state.sections))
        .catch(() => {
          select.classList.remove('is-loading');
          select.value = current;
        });
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  const drawer = () => qs('cart-drawer');

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-gl-cart-open]');
    if (!opener || !drawer()) return;
    event.preventDefault();
    drawer().open();
  });

  /* ---------- Producto: packs, precio y agregar al carrito ---------- */
  class GlProduct extends HTMLElement {
    connectedCallback() {
      const data = qs('[data-gl-variants]', this);
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.form = qs('[data-gl-product-form]', this);
      this.idInput = qs('[data-gl-variant-input]', this);
      this.mainButton = qs('[data-gl-main-atc]', this);
      this.stickyButton = qs('[data-gl-sticky-atc]', this);
      this.stickySelect = qs('[data-gl-sticky-select]', this);

      qsa('[data-gl-pack]', this).forEach((radio) => {
        radio.addEventListener('change', () => radio.checked && this.select(radio.value));
      });
      if (this.stickySelect) {
        this.stickySelect.addEventListener('change', () => this.select(this.stickySelect.value));
      }
      if (this.form) this.form.addEventListener('submit', (event) => this.addToCart(event));
      if (this.stickyButton) {
        this.stickyButton.addEventListener('click', () => {
          if (this.form.requestSubmit) this.form.requestSubmit();
          else this.form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }
      this.initSticky();
    }

    select(id) {
      const variant = this.variants.find((item) => String(item.id) === String(id));
      if (!variant) return;
      this.idInput.value = variant.id;
      qsa('[data-gl-pack]', this).forEach((radio) => { radio.checked = radio.value === String(variant.id); });
      if (this.stickySelect) this.stickySelect.value = String(variant.id);
      [['[data-gl-price-sale]', '[data-gl-price-compare]'], ['[data-gl-sticky-sale]', '[data-gl-sticky-compare]']].forEach(([saleSel, compareSel]) => {
        const sale = qs(saleSel, this);
        const compare = qs(compareSel, this);
        if (sale) sale.textContent = variant.price;
        if (compare) {
          compare.hidden = !variant.compare;
          compare.textContent = variant.compare || '';
        }
      });
      const label = qs('.gl-atc__label', this.mainButton);
      this.mainButton.disabled = !variant.available;
      if (label) label.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    addToCart(event) {
      event.preventDefault();
      const error = qs('[data-gl-form-error]', this);
      if (error) error.hidden = true;
      setBusy(this.mainButton, true);
      setBusy(this.stickyButton, true);
      postJSON('/cart/add.js', withDrawerSection({ items: [{ id: Number(this.idInput.value), quantity: 1 }] }))
        .then((response) => {
          const cart = drawer();
          if (cart) {
            cart.render(response.sections);
            cart.open();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch((problem) => {
          if (error) {
            error.textContent = problem.description || problem.message || 'No se pudo agregar al carrito.';
            error.hidden = false;
          }
        })
        .finally(() => {
          setBusy(this.mainButton, false);
          setBusy(this.stickyButton, false);
        });
    }

    initSticky() {
      const sticky = qs('[data-gl-sticky]', this);
      if (!sticky || !this.mainButton) return;
      const root = document.documentElement;
      const update = () => {
        const show = this.mainButton.getBoundingClientRect().bottom < 0;
        if (show === sticky.classList.contains('is-visible')) return;
        sticky.classList.toggle('is-visible', show);
        root.style.setProperty('--gl-sticky-offset', show ? `${sticky.offsetHeight}px` : '0px');
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }
  if (!customElements.get('gl-product')) customElements.define('gl-product', GlProduct);

  /* ---------- Galería ---------- */
  class GlGallery extends HTMLElement {
    connectedCallback() {
      this.list = qs('[data-gl-gallery-list]', this);
      this.items = qsa('.gl-gallery__item', this);
      this.thumbs = qsa('[data-gl-thumb]', this);
      this.thumbList = qs('[data-gl-thumbs]', this);
      this.prev = qs('[data-gl-prev]', this);
      this.next = qs('[data-gl-next]', this);
      this.thumbsPrev = qs('[data-gl-thumbs-prev]', this);
      this.thumbsNext = qs('[data-gl-thumbs-next]', this);
      this.index = 0;
      if (!this.list || this.items.length === 0) return;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.go(Number(thumb.dataset.glThumb)));
      });
      if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1));
      if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1));
      if (this.thumbsPrev) this.thumbsPrev.addEventListener('click', () => this.scrollThumbs(-1));
      if (this.thumbsNext) this.thumbsNext.addEventListener('click', () => this.scrollThumbs(1));

      let frame;
      this.list.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => this.syncFromScroll());
      }, { passive: true });
      if (this.thumbList) this.thumbList.addEventListener('scroll', () => this.updateThumbArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateThumbArrows());
      this.setActive(0);
    }

    go(index) {
      const target = Math.max(0, Math.min(this.items.length - 1, index));
      const item = this.items[target];
      this.list.scrollTo({ left: item.offsetLeft - this.list.offsetLeft, behavior: 'smooth' });
      this.setActive(target);
    }

    syncFromScroll() {
      const left = this.list.scrollLeft;
      let closest = 0;
      this.items.forEach((item, index) => {
        const offset = item.offsetLeft - this.list.offsetLeft;
        const best = this.items[closest].offsetLeft - this.list.offsetLeft;
        if (Math.abs(offset - left) < Math.abs(best - left)) closest = index;
      });
      if (closest !== this.index) this.setActive(closest);
    }

    setActive(index) {
      this.index = index;
      this.thumbs.forEach((thumb, i) => {
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (this.prev) this.prev.disabled = index === 0;
      if (this.next) this.next.disabled = index === this.items.length - 1;
      const active = this.thumbs[index];
      if (active && this.thumbList) {
        const item = active.parentElement;
        const start = item.offsetLeft - this.thumbList.offsetLeft;
        const end = start + item.offsetWidth;
        const view = this.thumbList.scrollLeft;
        if (start < view || end > view + this.thumbList.clientWidth) {
          this.thumbList.scrollTo({ left: start - 5, behavior: 'smooth' });
        }
      }
      this.updateThumbArrows();
    }

    scrollThumbs(direction) {
      if (!this.thumbList || !this.thumbs[0]) return;
      const step = this.thumbs[0].parentElement.offsetWidth + 10;
      this.thumbList.scrollBy({ left: direction * step * 3, behavior: 'smooth' });
    }

    updateThumbArrows() {
      if (!this.thumbList) return;
      const max = this.thumbList.scrollWidth - this.thumbList.clientWidth - 1;
      if (this.thumbsPrev) this.thumbsPrev.disabled = this.thumbList.scrollLeft <= 0;
      if (this.thumbsNext) this.thumbsNext.disabled = this.thumbList.scrollLeft >= max;
    }
  }
  if (!customElements.get('gl-gallery')) customElements.define('gl-gallery', GlGallery);

  /* ---------- Carrusel de reseñas ---------- */
  class GlReviews extends HTMLElement {
    connectedCallback() {
      this.viewport = qs('.gl-reviews__viewport', this);
      this.track = qs('.gl-reviews__track', this);
      this.slides = qsa('.gl-reviews__slide', this);
      this.index = 0;
      if (!this.track || this.slides.length < 2) return;
      this.delay = Number(this.dataset.autoplay) || 3500;
      this.paused = false;
      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });
      let startX = null;
      this.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; this.paused = true; }, { passive: true });
      this.addEventListener('touchend', (event) => {
        this.paused = false;
        if (startX === null) return;
        const delta = event.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) this.go(this.index + (delta < 0 ? 1 : -1));
        startX = null;
      });
      window.addEventListener('resize', () => this.go(this.index, true));
      window.addEventListener('load', () => this.go(this.index, true));
      this.go(0, true);
      setInterval(() => { if (!this.paused && !document.hidden) this.go(this.index + 1); }, this.delay);
    }

    go(index, instant) {
      const count = this.slides.length;
      this.index = ((index % count) + count) % count;
      const slide = this.slides[this.index];
      const step = slide.offsetWidth + parseFloat(getComputedStyle(slide).marginRight || 0);
      if (instant) this.track.style.transition = 'none';
      this.track.style.transform = `translateX(${-step * this.index}px)`;
      this.viewport.style.height = `${slide.offsetHeight}px`;
      if (instant) {
        this.track.getBoundingClientRect();
        this.track.style.transition = '';
      }
    }
  }
  if (!customElements.get('gl-reviews')) customElements.define('gl-reviews', GlReviews);

  /* ---------- Fechas de envío ---------- */
  function formatDate(offset) {
    const date = new Date();
    date.setDate(date.getDate() + offset);
    return `${date.getDate()} ${MONTHS[date.getMonth()]}`;
  }
  qsa('[data-gl-date]').forEach((element) => {
    const text = element.dataset.text || '';
    element.innerHTML = text
      .replace('[start_date]', formatDate(Number(element.dataset.min) || 0))
      .replace('[end_date]', formatDate(Number(element.dataset.max) || 0));
  });

  /* ---------- Volver arriba ---------- */
  const toTop = qs('[data-gl-to-top]');
  if (toTop) {
    const toggle = () => { toTop.hidden = window.scrollY <= 400; };
    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
    toTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* ---------- Espacio bajo el footer para la barra fija ---------- */
  const spacer = qs('[data-gl-sticky-spacer]');
  const stickyBar = qs('[data-gl-sticky]');
  const footer = qs('.gl-footer');
  if (spacer && stickyBar) {
    const sizeSpacer = () => {
      spacer.style.height = `${Math.max(0, stickyBar.offsetHeight - 1)}px`;
      if (footer) spacer.style.background = getComputedStyle(footer).background;
    };
    sizeSpacer();
    window.addEventListener('resize', sizeSpacer);
    window.addEventListener('load', sizeSpacer);
  }

  /* ---------- Aparición del footer ---------- */
  const reveals = qsa('.gl-reveal');
  if (footer && reveals.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      reveals.forEach((element) => element.classList.add('is-in'));
      observer.disconnect();
    }, { rootMargin: '0px 0px -40px 0px' });
    observer.observe(footer);
  } else {
    reveals.forEach((element) => element.classList.add('is-in'));
  }
})();
